<template>
  <!-- TODO: BBAR-3251 Remove tw-wrapper ID on full Tailwind conversion -->
  <Dialog
    v-bind="attrs"
    v-model:visible="computeVisible"
    modal
    :closeIcon="Icons.XMark"
    :style="{ width: modalWidth || '700px' }"
    :breakpoints="{ '1199px': '700px', '750px': '90vw' }"
    :draggable="false"
    @after-hide="onAfterHide"
    @hide="onHide"
    :contentClass="hideContent ? 'tw-hidden' : undefined"
    :appendTo="appendTo || '#tw-wrapper'">
    <template v-for="(slot, name) in $slots" #[name]="slotProps" v-bind:key="name">
      <component :is="slot" v-bind="slotProps" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, useAttrs } from 'vue'
import Dialog, { DialogSlots } from 'primevue/dialog'
import { LocalStorageService } from '@/services/LocalStorageService'
import { ModalEmits, ModalProps, ModalStates } from '.'
import { Icons } from '@/enums/components.enum'

const attrs = useAttrs()
defineSlots<Partial<DialogSlots>>()
const props = defineProps<ModalProps>()
const emit = defineEmits<ModalEmits>()
const model = defineModel<boolean>('visible')

const hasLocalStorage = computed(() => {
  if (!props.localStorageKey) return false
  return LocalStorageService.getItem(props.localStorageKey) === ModalStates.VIEWED
})

const computeVisible = computed({
  get() {
    if (hasLocalStorage.value) return false
    return model.value
  },
  set(value) {
    model.value = value
  }
})

function onAfterHide() {
  emit('after-hide')
  if (props.localStorageKey) {
    LocalStorageService.setItem(props.localStorageKey, ModalStates.VIEWED)
  }
}

function onHide() {
  emit('hide')
}
</script>

<style>
@import '@/assets/css/backbarVariables.css';

.p-dialog-close-button {
  color: var(--icon-default) !important;
}

.p-dialog-content {
  border-top: 1px solid var(--border-default-color) !important;
}

.p-dialog-footer {
  border-top: 1px solid var(--border-default-color) !important;
}
</style>
